/* eslint-disable camelcase */
import React from 'react'

import logUtil from 'utils/log'
import View from 'components/View'
import Span from 'components/Span'

export default function ProductColorOption (props) {
  const { colorOption } = props

  logUtil('ProductColorOption').debug('[start] props=', props)

  return (
    <View className='product-color-option'>
      <Span>{colorOption}</Span>
    </View>
  )
}
